import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { useDistributionMergingUIContext } from "./MergingUIContext";
import DistributionMergingTable from "./merging-table/MergingTable";
import { DistributionMergingFilter } from "./merging-filter/MergingFilter";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { DistributionMergingEditForm } from "./merging-edit-dialog/MergingEditForm";
import { useDispatch } from "react-redux";
import * as actions from "../_redux/mergingAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import ConfirmationModal from "../../../../../_metronic/layout/components/confirmation-modal/ConfirmationModal";

export const DistributionMergingCard = ({ history }) => {
  const dispatch = useDispatch();

  // ! NOTES
  // ! FIND QUOTA WITH merge_to_livestock_uuid
  // ! FILTER WITH livestock_uuid
  // ! DISTRIBUTION DATA WITH merge_to_livestock_uuid

  // ? CURRENT STOCK
  const [currentStock, setCurrentStock] = useState(0);

  // ? DATA FOR FILTER
  const [currentData, setCurrentData] = useState({
    thk_livestock_uuid: "",
    limit: "",
    name: "",
    donation_hid: "",
    is_merging: true,
  });

  const getDistributionList = () => {
    dispatch(actions.fetchDistributionMergings(currentData));
  };

  // ? DATA FOR DISTRIBUTION
  const [distributionData, setDistributionData] = useState({
    thk_livestock_uuid: "",
    thk_area_uuid: "",
    thk_partner_uuid: "",
    is_merging: true,
    donation_item_uuids: [],
  });

  const submitDistribution = () => {
    // ! CHECK DONATION IS MULTIPLY 7
    let totalDonation = Math.floor(
      distributionData.donation_item_uuids.length / 7
    );

    if (distributionData.donation_item_uuids.length % 7 != 0) {
      const errStr = `Donasi 1/7 Sapi anda kurang ${(totalDonation + 1) * 7 -
        distributionData.donation_item_uuids
          .length} donasi lagi untuk di merging menjadi ${totalDonation +
        1} Kurban Sapi`;
      toast.error(errStr, toastOption);
      return;
    } else {
      dispatch(actions.submitDistribution(distributionData)).then((res) => {
        setConfirmationModal(false);
        toast.success(
          "Berhasil mendistribusikan donasi 1/7 sapi!",
          toastOption
        );
        history.push("/kurban/distribution/merging");
      });
    }
  };

  // * MODAL
  const [confirmationModal, setConfirmationModal] = useState(false);

  return (
    <>
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        title="Distribusikan Donasi"
        content={`Anda yakin ingin mendistribusikan ${distributionData.donation_item_uuids.length} donasi?`}
        type="info"
        onClick={submitDistribution}
      />
      <Card>
        <CardHeader title="Pendistribusian 1/7 Sapi" />
        <CardBody>
          <DistributionMergingFilter
            // ? DATA FOR FILTER
            currentData={currentData}
            setCurrentData={setCurrentData}
            // ? DATA FOR DISTRIBUTION
            distributionData={distributionData}
            setDistributionData={setDistributionData}
            // ? STOCK
            setCurrentStock={setCurrentStock}
          />
        </CardBody>
      </Card>
      <DistributionMergingEditForm
        setCurrentData={setCurrentData}
        currentData={currentData}
        onSubmit={getDistributionList}
        currentStock={currentStock}
      />
      <Card>
        <CardHeader title="List Pendistribusian" />
        <CardBody>
          <DistributionMergingTable
            distributionData={distributionData}
            setDistributionData={setDistributionData}
            onSubmit={() => setConfirmationModal(true)}
          />
        </CardBody>
      </Card>
    </>
  );
};
